import { useEffect, useState } from "react";
import { Plus, Pause, Play, Pencil, Trash2, Tag, Calendar, BarChart3, Percent, IndianRupee, MapPin } from "lucide-react";
import {
  Button,
  EmptyState,
  FilterTabs,
  PageHeader,
  StatusBadge,
  Surface,
  Text,
} from "@/components/flup";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Checkbox } from "@/components/ui/checkbox";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { toast } from "sonner";
import { createVendorDiscount, getCompletedVenueDetails, getVendorDiscounts, toggleVendorDiscount } from "@/store/thunkMidddleware/turfMiddleware";
import { useAppDispatch, useAppSelector } from '@/hooks/useReduxHooks'
import { Loader2 } from "lucide-react";
import { Values } from "@/constants/Values";
import { CreateVendorDiscountType, GetVendorDiscountType } from "@/types/interfaceType";
import { getISTEndOfDay, getISTStartDate, MomentformatTime } from "@/lib/utils";
import { ButtonWithLoader } from "../ui/buttonwithloader";
interface Offer {
  id?: string;
  title?: string;
  type?: "percentage" | "flat";
  value?: number;
  venue?: string;
  sports?: string[];
  courts?: string[];
  allSports?: boolean;
  allCourts?: boolean;

  status?: "active" | "paused" | "expired";
  usageCount?: number;



   venueId?:string,
            discountType?:string,
            discountValue?:number,
            discountApplyType?:string,
            applicableSports ?:string[],
            applicableCourts?: string[],
            applyToAllSports ?:boolean,
            applyToAllCourts? : boolean,
            startDate ?:string,
            endDate ?: string
}


type TimeDuration = "24hr" | "12hr" | "6hr" | "custom";


const sampleOffers: Offer[] = [
  {
    id: "1", title: "Weekend Special", type: "percentage", value: 10, venue: "BYZ Sports Arena",
    sports: ["Cricket"], courts: ["Turf 1"], allSports: false, allCourts: false,
    startDate: "2026-03-20", endDate: "2026-03-25", status: "active", usageCount: 45,
  },
  {
    id: "2", title: "Summer Bonanza", type: "flat", value: 100, venue: "BYZ Downtown Hub",
    sports: [], courts: [], allSports: true, allCourts: true,
    startDate: "2026-03-15", endDate: "2026-04-15", status: "active", usageCount: 128,
  },
  {
    id: "3", title: "Early Bird Discount", type: "percentage", value: 15, venue: "BYZ Green Fields",
    sports: ["Badminton"], courts: ["Court A", "Court B"], allSports: false, allCourts: false,
    startDate: "2026-03-10", endDate: "2026-03-18", status: "paused", usageCount: 22,
  },
  {
    id: "4", title: "Launch Offer", type: "flat", value: 200, venue: "BYZ Elite Club",
    sports: ["Football"], courts: ["Ground 1"], allSports: false, allCourts: false,
    startDate: "2026-02-01", endDate: "2026-02-28", status: "expired", usageCount: 89,
  },
];

const sportOptions = ["Cricket", "Football", "Badminton", "Tennis", "Basketball"];
const courtOptions = ["Turf 1", "Turf 2", "Court A", "Court B", "Ground 1"];

const formatDate = (d: string) => {
  const date = new Date(d);
  // return date.toLocaleDateString("en-IN", { day: "numeric", month: "short" });
  return MomentformatTime(date)
};


const renderLoader=()=>{
  return  <Loader2 className="animate-spin w-12 h-12 mx-auto mt-10" />

}
const OffersManagement = () => {
  const [activeTab, setActiveTab] = useState<"active" | "paused" | "expired">("active");
  const [modalOpen, setModalOpen] = useState(false);
    const dispatch = useAppDispatch()
   const venueState = useAppSelector((state) => state.turf);

  //  const completedVenueDetails = useAppSelector((state) => state.turf.completedVenueDetails);
    
  const [selectedVenue, setSelectedVenue] = useState("");
    const [selectedVenueDetails, setSelectedVenueDetails] = useState(null);
 const [applyOn, setApplyOn] = useState<"TOTAL" | "PER_SLOT">("PER_SLOT");
  const [discountType, setDiscountType] = useState< "PERCENT" | "FLAT">("PERCENT");
  const [discountValue, setDiscountValue] = useState("");
    const [discountName, setDiscountName] = useState("");

  const [allSports, setAllSports] = useState(true);
  const [selectedSports, setSelectedSports] = useState<string[]>([]);


      const [selectedSportsDetails, setSelectedSportsDetails] = useState([]);
      const [selectedCourtDetails, setselectedCourtDetails] = useState([]);


  const [allCourts, setAllCourts] = useState(true);
  const [selectedCourts, setSelectedCourts] = useState<string[]>([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
    const [timeDuration, setTimeDuration] = useState<TimeDuration>("24hr");
  const [timeFrom, setTimeFrom] = useState("00:00");
  const [timeTo, setTimeTo] = useState("23:59");

  const filteredOffers =  venueState.getVendorDiscountsResponse?.payload?.discounts?.filter((o) => o);



    const getDefaultTimes = (duration: TimeDuration) => {
    switch (duration) {
      case "24hr": return { from: "00:00", to: "23:59" };
      case "12hr": return { from: "06:00", to: "18:00" };
      case "6hr": return { from: "06:00", to: "12:00" };
      case "custom": return { from: timeFrom, to: timeTo };
    }
  };

  const handleTimeDurationChange = (d: TimeDuration) => {
    setTimeDuration(d);
    const times = getDefaultTimes(d);
    setTimeFrom(times.from);
    setTimeTo(times.to);
  };

console.log(timeDuration,timeFrom,timeTo)

//   console.log("offers:",offers,
//      "selectedVenue:",selectedVenue,
//     "selectedSports:",selectedSports,
// "selectedCourts:",selectedCourts,

// "---------------------------------",
//     "selectedVenueDetails:",selectedVenueDetails,

//     "selectedSportsDetails:",selectedSportsDetails,
//     "selectedCourtDetails:",selectedCourtDetails,
  
//   )
   const fetchCompletedVenueDetails = () => {
      dispatch(getCompletedVenueDetails({
        callback: (res) => {
          console.log("getCompletedVenueDetails:", res)
      
        }
      }))
    }

     const fetchOffers = (page=1,status:string) => {
      dispatch(getVendorDiscounts({
        page:1,
        queryParams:{limit:10,page:page,status},
        callback: (res) => {
          console.log("getVendorDiscounts:", res)
      
        }
      }))
    }

    useEffect(()=>{
      fetchCompletedVenueDetails()
    },[])
    

    useEffect(()=>{
       fetchOffers(1,activeTab)
    },[activeTab])

  const toggleStatus = (id: string, newStatus: "active" | "paused") => {
    dispatch(toggleVendorDiscount({pathparams:id,callback:(res)=>{
        if(res){
          fetchOffers(1,activeTab)
    toast.success(newStatus === "paused" ? "Offer paused" : "Offer resumed");
        }
    }}))
  };

  const deleteOffer = (id: string) => {
    toast.success("Delete coming soon");
  };

  const resetForm = () => {
    setSelectedVenue("");

    setselectedCourtDetails([])
    setSelectedSportsDetails([])
    setSelectedVenueDetails(null)
    setDiscountName("")
    

    setDiscountType(Values.discountApplyType.obj.PERCENT as "PERCENT");
    setDiscountValue("");
    setAllSports(true);
    setSelectedSports([]);
    setAllCourts(true);
    setSelectedCourts([]);
    setStartDate("");
    setEndDate("");
  };


  const createDiscount=(payload:CreateVendorDiscountType)=>{
      dispatch(createVendorDiscount({payload,callback:(res)=>{
        if(res?.success){
              toast.success("Offer created successfully! 🎉");
              fetchOffers(1,activeTab)
                 setModalOpen(false);
                 resetForm();
        }else{

        }
      }}))
  }

  const handleCreate = () => {
    if (!selectedVenue || !discountValue || !startDate || !endDate) {
      toast.error("Please fill all required fields");
      return;
    }
   
    let newstartDate= getISTStartDate(startDate)
    let newendDate= getISTEndOfDay(endDate)
    createDiscount({
      discountName:discountName,
      applicableCourts:allCourts ? [] : selectedCourts,
      applicableSports: allSports ? [] : selectedSports,
      applyToAllCourts:allCourts,
      applyToAllSports:allSports,
      discountApplyType:applyOn,
      discountType:discountType,
      discountValue:Number(discountValue),
      endDate:newendDate,
      startDate:newstartDate,
      venueId:selectedVenue,
      isFullDay:timeDuration === Values.timeDuration._24hr,
      offerStartTime:timeFrom,
      offerEndTime:timeTo
    })
    // setModalOpen(false);
    // resetForm();
  };

  const toggleArrayItem = (arr: string[], item: string) =>
    arr.includes(item) ? arr.filter((x) => x !== item) : [...arr, item];

  const toggleNestedArrayItems = (arr: any[], items: any[]) => {
  let result = [...arr];

  items.forEach((item) => {
    const exists = result.some((x) => x._id === item._id); // adjust key

    if (exists) {
      result = result.filter((x) => x._id !== item._id);
    } else {
      result.push(item);
    }
  });

  return result;
};

  // const tabCounts = {
  //   active: venueState.getVendorDiscountsResponse?.payload?.discounts?.filter((o) => o.status === "active").length,
  //   paused: venueState.getVendorDiscountsResponse?.payload?.discounts?.filter((o) => o.status === "paused").length,
  //   expired: venueState.getVendorDiscountsResponse?.payload?.discounts?.filter((o) => o.status === "expired").length,
  // };

  const tabs: { key: "active" | "paused" | "expired"; label: string }[] = [
    { key: "active", label: "Active" },
    { key: "paused", label: "Paused" },
    { key: "expired", label: "Expired" },
  ];

  const loadingOffers =
    venueState.completedVenueDetails.isLoading || venueState.getVendorDiscountsResponse.isLoading;

  return (
    <div className="space-y-4">
      <PageHeader
        title="Offers"
        count={filteredOffers?.length ? `${filteredOffers.length} offers` : undefined}
        subtitle="Discounts that fill your quiet hours."
        actions={
          <Button
            icon={<Plus className="h-4 w-4" />}
            onClick={() => {
              resetForm();
              setModalOpen(true);
            }}
          >
            Create offer
          </Button>
        }
      />

      <FilterTabs
        items={tabs.map((tab) => ({ key: tab.key, label: tab.label }))}
        value={activeTab}
        onChange={(key) => setActiveTab(key as typeof activeTab)}
      />

      {loadingOffers ? (
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {Array.from({ length: 3 }).map((_, i) => (
            <div
              key={i}
              className="h-[260px] rounded-flup-lg bg-flup-surface border border-flup-hairline animate-pulse"
            />
          ))}
        </div>
      ) : !filteredOffers?.length ? (
        <Surface padding={false}>
          <EmptyState
            icon={<Tag />}
            title="No offers here yet"
            message="A discount is the fastest way to move slots nobody is booking. Create one and it applies the moment it starts."
            actionLabel="Create offer"
            onAction={() => {
              resetForm();
              setModalOpen(true);
            }}
          />
        </Surface>
      ) : (
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {filteredOffers?.map((offer, idx) => (
            <OfferCard
              key={idx}
              offer={offer}
              onPause={() => toggleStatus(offer?.id, "paused")}
              onResume={() => toggleStatus(offer?.id, "active")}
              onDelete={() => deleteOffer(offer?.id)}
              onEdit={() => toast.info("Edit coming soon")}
            />
          ))}
        </div>
      )}

      {/* Create Offer Modal */}
      <Dialog open={modalOpen} onOpenChange={setModalOpen}>
        <DialogContent className="max-h-[90vh] overflow-y-auto rounded-2xl border-0 bg-flup-surface p-0 shadow-2xl sm:max-w-lg">
          <div className="bg-flup-brand px-6 py-5 text-white">
            <DialogHeader>
              <DialogTitle className="text-xl font-bold text-white">Create new offer</DialogTitle>
              <DialogDescription className="text-white/80">
                Set up a discount to attract more bookings
              </DialogDescription>
            </DialogHeader>
          </div>

          <div className="space-y-5 px-6 pb-6">
            {/* Select Venue */}
            <div className="space-y-2">
              <Label className="text-sm font-semibold text-foreground">Select Venue*</Label>
              <Select value={selectedVenue} onValueChange={(id)=>{
                setSelectedVenue(id)
                setSelectedVenueDetails(venueState?.completedVenueDetails?.payload?.find(ele=>ele?._id===id))
              }}>
                <SelectTrigger className="rounded-xl">
                  <div className="flex items-center gap-2">
                    <MapPin className="h-4 w-4 text-muted-foreground" />
                    <SelectValue placeholder="Choose a venue" />
                  </div>
                </SelectTrigger>
                <SelectContent>
                  {venueState?.completedVenueDetails?.payload?.map((v,idx) => (
                    <SelectItem key={idx} value={v?._id}>{v?.name}</SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>


          {/* Apply Discount On */}
            {/* <div className="space-y-2">
              <Label className="text-sm font-semibold text-foreground">Apply Discount On*</Label>
              <RadioGroup value={applyOn} onValueChange={(v) => setApplyOn(v as "TOTAL" | "PER_SLOT")} className="flex gap-3">
                <label className={`flex flex-1 cursor-pointer items-center gap-2.5 rounded-xl border-2 p-3.5 transition-all ${applyOn === Values.discountAppliedOn.obj.TOTAL  ? "border-[hsl(210,90%,55%)] bg-[hsl(210,90%,97%)]" : "border-border hover:border-muted-foreground/30"}`}>
                  <RadioGroupItem value={Values.discountAppliedOn.obj.TOTAL} />
                  <span className="text-sm font-medium">Total Booking</span>
                </label>
                <label className={`flex flex-1 cursor-pointer items-center gap-2.5 rounded-xl border-2 p-3.5 transition-all ${applyOn ===  Values.discountAppliedOn.obj.PER_SLOT ? "border-[hsl(210,90%,55%)] bg-[hsl(210,90%,97%)]" : "border-border hover:border-muted-foreground/30"}`}>
                  <RadioGroupItem value={Values.discountAppliedOn.obj.PER_SLOT} />
                  <span className="text-sm font-medium">Per Slot</span>
                </label>
              </RadioGroup>
            </div> */}

            {/* Discount Type */}
            <div className="space-y-2">
              <Label className="text-sm font-semibold text-foreground">Discount Type*</Label>
              <RadioGroup value={discountType} onValueChange={(v) => setDiscountType(v as "PERCENT" | "FLAT")} className="flex gap-3">
                <label className={`flex flex-1 cursor-pointer items-center gap-2.5 rounded-xl border-2 p-3.5 transition-all ${discountType === Values.discountApplyType.obj.PERCENT ? "border-[hsl(210,90%,55%)] bg-[hsl(210,90%,97%)]" : "border-border hover:border-muted-foreground/30"}`}>
                  <RadioGroupItem value={Values.discountApplyType.obj.PERCENT} />
                  <Percent className="h-4 w-4 text-[hsl(210,90%,55%)]" />
                  <span className="text-sm font-medium">Percentage</span>
                </label>
                <label className={`flex flex-1 cursor-pointer items-center gap-2.5 rounded-xl border-2 p-3.5 transition-all ${discountType === Values.discountApplyType.obj.FLAT ? "border-[hsl(160,60%,45%)] bg-[hsl(160,60%,96%)]" : "border-border hover:border-muted-foreground/30"}`}>
                  <RadioGroupItem value={Values.discountApplyType.obj.FLAT} />
                  <IndianRupee className="h-4 w-4 text-[hsl(160,60%,45%)]" />
                  <span className="text-sm font-medium">Flat Amount</span>
                </label>
              </RadioGroup>
            </div>

            {/* Discount Value */}
            <div className=" flex gap-2 justify-center items-center ">


              <div className="w-1/2">
                <Label className="text-sm font-semibold text-foreground">Discount Name*</Label>
                <div className="relative">
                  {/* <span className="absolute left-2 top-1/2 -translate-y-1/2 text-muted-foreground text-sm">
                    {discountType === Values.discountApplyType.obj.PERCENT  ? "%" : "₹"}
                  </span> */}
                  <Input
                    type="text"
                    placeholder={"Enter Discount Name"}
                    value={discountName}
                    onChange={(e) => setDiscountName(e.target.value)}
                    className="rounded-lg pl-2 w-full"
                  />
                </div>
              </div>

              <div className=" w-1/2">
                <Label className="text-sm font-semibold text-foreground">Discount Value*</Label>
                  <div className="relative">
                    <span className="absolute left-2 top-1/2 -translate-y-1/2 text-muted-foreground text-sm">
                      {discountType === Values.discountApplyType.obj.PERCENT  ? "%" : "₹"}
                    </span>
                    <Input
                      type="number"
                      placeholder={discountType === Values.discountApplyType.obj.PERCENT  ? "e.g. 10" : "e.g. 100"}
                      value={discountValue}
                      onChange={(e) => setDiscountValue(e.target.value)}
                      className="rounded-lg pl-2 w-full"
                    />
                  </div>
              </div>
            </div>


            {/* <div className="space-y-2">
              <Label className="text-sm font-semibold text-foreground">Discount Value*</Label>
              <div className="relative">
                <span className="absolute left-2 top-1/2 -translate-y-1/2 text-muted-foreground text-sm">
                  {discountType === Values.discountApplyType.obj.PERCENT  ? "%" : "₹"}
                </span>
                <Input
                  type="number"
                  placeholder={discountType === Values.discountApplyType.obj.PERCENT  ? "e.g. 10" : "e.g. 100"}
                  value={discountValue}
                  onChange={(e) => setDiscountValue(e.target.value)}
                  className="rounded-xl pl-6"
                />
              </div>
            </div> */}

            {/* Apply To */}
           { <div className="space-y-3 rounded-xl border border-border bg-muted/30 p-4">
              <p className="text-sm font-semibold text-foreground">Apply To</p>

              <div className="flex items-center gap-2">
                <Checkbox checked={allSports} onCheckedChange={(v) => setAllSports(!!v)}  disabled={!selectedVenueDetails}/>
                <span className="text-sm">All Sports</span>
              </div>
              {!allSports && (
                <div className="flex flex-wrap gap-2 pl-6">
                  {selectedVenueDetails?.sports?.map((s,idx) => (
                    <button
                    disabled={!selectedVenueDetails}
                      key={idx}
                      onClick={() => {
                        setSelectedSports(toggleArrayItem(selectedSports, s?._id))
                        setSelectedSportsDetails(toggleArrayItem(selectedSportsDetails, s))

                        setselectedCourtDetails(toggleNestedArrayItems(selectedCourtDetails, s?.courts))
                      }}
                      className={`rounded-lg border px-3 py-1.5 text-xs font-medium transition-all ${
                        selectedSports.includes(s?._id)
                          ? "border-[hsl(210,90%,55%)] bg-[hsl(210,90%,95%)] text-[hsl(210,90%,45%)]"
                          : "border-border text-muted-foreground hover:border-muted-foreground/40"
                      }`}
                    >
                      {s?.sportType}
                    </button>
                  ))}
                </div>
              )}

              <div className="flex items-center gap-2">
                <Checkbox checked={allCourts} onCheckedChange={(v) => setAllCourts(!!v)}  disabled={!selectedVenueDetails}/>
                <span className="text-sm">All Courts</span>
              </div>
              {!allCourts && selectedCourtDetails && (
                <div className="flex flex-wrap gap-2 pl-6">
                  {selectedCourtDetails?.map((c,idx) => (
                    <button
                       disabled={!selectedVenueDetails}
                      key={idx}
                      onClick={() => setSelectedCourts(toggleArrayItem(selectedCourts, c?._id))}
                      className={`rounded-lg border px-3 py-1.5 text-xs font-medium transition-all ${
                        selectedCourts.includes(c?._id)
                          ? "border-[hsl(160,60%,45%)] bg-[hsl(160,60%,94%)] text-[hsl(160,60%,35%)]"
                          : "border-border text-muted-foreground hover:border-muted-foreground/40"
                      }`}
                    >
                      {c?.courtName}
                    </button>
                  ))}
                </div>
              )}
            </div>}

            {/* Dates */}
            <div className="grid grid-cols-2 gap-3">
              <div className="space-y-2">
                <Label className="text-sm font-semibold text-foreground">Start Date</Label>
                <Input                
                        disabled={!selectedVenueDetails}
              type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} className="rounded-xl" />
              </div>
              <div className="space-y-2">
                <Label className="text-sm font-semibold text-foreground">End Date</Label>
                <Input 
                 disabled={!selectedVenueDetails}
                type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} className="rounded-xl" />
              </div>
            </div>

            <Button size="lg" fullWidth onClick={handleCreate}>
              Create offer
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
};

/* ─── Offer Card ─── */

const statusConfig = {
  active: { label: "Active", className: "bg-[hsl(142,55%,92%)] text-[hsl(142,55%,30%)]" },
  paused: { label: "Paused", className: "bg-[hsl(38,92%,92%)] text-[hsl(38,60%,35%)]" },
  expired: { label: "Expired", className: "bg-[hsl(0,84%,93%)] text-[hsl(0,60%,40%)]" },
};

const OfferCard = ({
  offer,
  onPause,
  onResume,
  onEdit,
  onDelete,
}: {
  offer: GetVendorDiscountType;
  onPause: () => void;
  onResume: () => void;
  onEdit: () => void;
  onDelete: () => void;
}) => {
  const emoji = offer.discountType === Values.discountApplyType.obj.PERCENT ? "🔥" : "💰";
  const discountLabel = offer.discountType === Values.discountApplyType.obj.PERCENT ? `${offer?.discountValue}% OFF` : `₹${offer?.discountValue} OFF`;
  const scope = offer.applyToAllSports && offer.applyToAllCourts
    ? "All Sports • All Courts"
    : `${offer.applyToAllSports ? "All Sports" : offer.sports.map(ele=>ele.name).join(", ")} • ${offer.applyToAllCourts ? "All Courts" : offer.courts.map(ele=>ele.name).join(", ")}`;
  const status = statusConfig[offer.status];

  return (
    <Surface padding="p-5" className="flex flex-col transition-colors hover:border-flup-hairline-2">
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <div className="flex items-baseline gap-2 flex-wrap">
            <Text variant="h2" as="p">
              {emoji} {discountLabel}
            </Text>
            <Text variant="micro" tone="tertiary" as="span">
              {offer?.discountType}
            </Text>
          </div>
          <Text variant="caption" tone="secondary" as="p" className="mt-1" lines={1}>
            {offer?.discountName}
          </Text>
        </div>
        <StatusBadge status={offer.status} label={status.label} />
      </div>

      <div className="mt-4 space-y-2.5 flex-1">
        <CardLine icon={<MapPin className="h-3.5 w-3.5" />}>{offer.venue?.toUpperCase()}</CardLine>
        <CardLine icon={<Tag className="h-3.5 w-3.5" />}>{scope}</CardLine>
        <CardLine icon={<Calendar className="h-3.5 w-3.5" />}>
          {formatDate(offer.startDate)} → {formatDate(offer.endDate)}
        </CardLine>
        <CardLine icon={<BarChart3 className="h-3.5 w-3.5" />}>
          {`Applies to the ${offer?.discountApplyType === "TOTAL" ? "total amount" : "price of each slot"}`}
        </CardLine>
      </div>

      <div className="mt-4 flex gap-2 border-t border-flup-hairline pt-4">
        {offer.status === "active" && (
          <>
            <Button variant="secondary" size="sm" onClick={onPause} icon={<Pause className="h-3.5 w-3.5" />} className="flex-1">
              Pause
            </Button>
            <Button variant="secondary" size="sm" onClick={onEdit} icon={<Pencil className="h-3.5 w-3.5" />} className="flex-1">
              Edit
            </Button>
          </>
        )}
        {offer.status === "paused" && (
          <Button variant="green" size="sm" onClick={onResume} icon={<Play className="h-3.5 w-3.5" />} className="flex-1">
            Resume
          </Button>
        )}
        <Button variant="danger" size="sm" onClick={onDelete} aria-label="Delete offer">
          <Trash2 className="h-3.5 w-3.5" />
        </Button>
      </div>
    </Surface>
  );
};

/** Icon + one fact, the repeated row inside an offer card. */
const CardLine: React.FC<{ icon: React.ReactNode; children: React.ReactNode }> = ({
  icon,
  children,
}) => (
  <div className="flex items-center gap-2 min-w-0">
    <span className="text-flup-ink-3 shrink-0">{icon}</span>
    <Text variant="caption" tone="secondary" as="span" lines={1}>
      {children}
    </Text>
  </div>
);

export default OffersManagement;